module.exports = __webpack_public_path__ + "static/img/FK.cd9fc650.png";